import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/rem';

  .UserCreateForm {
    max-width: rem(388px);

    &__inputs-inner,
    &__actions {
      display: flex;
      align-items: center;
      justify-content: space-between;

      :global(.BaseTextField),
      :global(.DefaultButton) {
        width: 48%;
      }
    }

    &__actions {
      margin-top: 16px;
    }
  }
`;

export default staticStyles;
